<template>
	<section class="impact-section" :class="$i18n.locale">
		<div class="container">
			<div class="animation-container" v-if="desktop">
				<h2 class="fadeInUp animated delay-800">{{ $t('Impact.title') }}</h2>
				<div class="fadeInUp animated delay-1000">
					<p v-html="$t('Impact.paragraph_1')"></p>
					<p v-html="$t('Impact.paragraph_2')"></p>
				</div>
			</div>
			<div class="animation-container" v-if="!desktop">
				<h2 class="fadeInUp" v-wow="{
				'animation-duration': '1s',
			}">{{ $t('Impact.title') }}</h2>
			<div
			class="fadeInUp"
			v-wow="{
			'animation-duration': '1s',
			'animation-delay': '0.3s',
		}"
		>
		<p v-html="$t('Impact.paragraph_1')"></p>
		<p v-html="$t('Impact.paragraph_2')"></p>
	</div>
</div>
<ul class="values">
	<ImpactItem v-for="(impact, index) in impacts" :key="index" :impact="impact" />
</ul>
</div>
</section>
</template>

<script>
	import ImpactItem from '../partials/ImpactItem.vue'
	export default {
		name: 'Impact',
		components: { ImpactItem },
		computed: {
			impacts() {
				return this.$t('Impact.impacts')
			},
		},
		data() {
			return {
				desktop: true,
			}
		},
		created() {
			if (window.innerWidth < 768) {
				this.desktop = false
			}
		},
	}
</script>

<style scoped lang="scss">
	.impact-section {
		background-color: $blueTheme;
		background-image: url('~@/assets/img/impact-bg.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		color: $white;
	}

	h2 {
		margin-bottom: 30px;
		text-align: center;
		text-transform: uppercase;
	}

	p {
		@extend %montserrat-medium;
		color: $white;
		font-size: 17px;
		line-height: 28px;
		text-align: center;
		max-width: 900px;
		margin: 0 auto 10px;
	}

	.fr {
		p {
			max-width: 1060px;
		}
	}

	.values {
		@include flex-container(center);
		margin: 40px auto 0;
	}

	@include mobile {

		.impact-section {
			background-image: none;
			padding-top: 160px;
		}

		h2 {
			font-size: 55px;
		}

		.values {
			margin: 30px auto 0;
		}
	}
</style>
